import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from '../../utility/axiosInstance';
import { handleAxiosError } from '../../helpers/handleAxiosError';

export interface Keypair {
    name: string;
    fingerprint: string;
    public_key?: string;
    user_id?: string;
    created_at?: string;
}

interface KeypairItemState {
    data: Keypair[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: KeypairItemState = {
    data: [],
    status: 'idle',
    error: null,
};

export const fetchKeypairs = createAsyncThunk(
    'keypairs/fetchKeypairs',
    async (_, { rejectWithValue }) => {
        console.log("🔥 fetchKeypairs thunk triggered");

        try {
            const response = await axiosInstance.get('/v1/keypairs');

            if (!Array.isArray(response.data)) {
                throw new Error("Expected array of keypairs");
            }

            return response.data.map((item: any) => item.keypair);
        } catch (error) {
            console.error("Failed to fetch keypairs:", error);
            return rejectWithValue(handleAxiosError(error));
        }
    }
);

const keypairsSlice = createSlice({
    name: 'keypairs',
    initialState,
    reducers: {
        resetKeypairs: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchKeypairs.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchKeypairs.fulfilled, (state, action: PayloadAction<any[]>) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchKeypairs.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
                state.data = [];
            });
    },
});

export const { resetKeypairs } = keypairsSlice.actions;
export default keypairsSlice.reducer;